/** Matches "Slide 1 of 8", "Slide 1/8", case-insensitive. */
export const CAROUSEL_SLIDE_MARKER_RE = /Slide\s+\d+\s*(?:\/|of)\s*\d+/gi;

export function countCarouselSlideMarkers(content: string | null | undefined): number {
  if (!content) return 0;
  const matches = content.match(CAROUSEL_SLIDE_MARKER_RE);
  return matches?.length ?? 0;
}

/**
 * True when humanized content keeps at least as many slide markers as the original.
 * Single-slide or non-carousel originals always pass.
 */
export function preservesCarouselSlideCount(
  original: string | null | undefined,
  humanized: string | null | undefined
): boolean {
  const originalCount = countCarouselSlideMarkers(original);
  if (originalCount < 2) return true;
  return countCarouselSlideMarkers(humanized) >= originalCount;
}

/**
 * A line that starts a slide: "Slide 1 of 8", "Slide 1/8", "Slide 1:",
 * "**Slide 1 of 8**", with the body on the next line or after a blank line.
 */
const SLIDE_LINE = /^[^\S\n]*(?:[*_#>]+[^\S\n]*)?Slide\s+(\d{1,2})\b/gim;

/**
 * THE slide-deck rule: text written as a slide deck has a line starting
 * "Slide 1" and a line starting "Slide 2". A carousel's copy lives in the
 * script field, so everything that decides "is this a carousel or a script"
 * (section heading, handoff kind, lock receipt, thread cards) asks this.
 *
 * Mirrored word for word in apps/backend/src/items/_shared/carousel-slide-markers.ts;
 * utils/__tests__/carousel-slide-deck-rule.test.ts runs both on the same cases.
 */
export function isSlideDeckText(text: string | null | undefined): boolean {
  if (!text) return false;
  const numbers = new Set(Array.from(text.matchAll(SLIDE_LINE), match => Number(match[1])));
  return numbers.has(1) && numbers.has(2);
}
